import { render, staticRenderFns } from "./CardList.vue?vue&type=template&id=e12e7ffa&"
import script from "./CardList.vue?vue&type=script&lang=js&"
export * from "./CardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports